import { IntersectItemType } from './ItemInfoCollection';
import { FreeText, Room } from '../item';

class AuxiliaryConstructionCollection{
  public guid:string;   //PINのGUID
  public id:string;
  public auxiliary_construction_name:string;
  public note:string;
  public quantity:number;
  public unit:string;
  public unit_price:number;
  public total_price:number;
  public debtor_burden_rate:number;
  public repair_reason:string;
  public other_flag:boolean;
  public estimatedEntryFlg:number;
  public other_text: string;
  public intersectItem:IntersectItemType;
  public parentPin:FreeText;
  public parentRoom:Room;
  public room_name:string;

  /**
   * コンストラクタ
   */
  constructor() {
  }
}
export default AuxiliaryConstructionCollection;
